export const modalTypes = {
  tenant: 'tenant',
  account: 'account',
};

export const buttonTypes = {
  simple: 'simple',
};
